/**
 * Label Mapping Utilities
 *
 * Shared helpers for mapping label IDs stored on leads/properties
 * to full label objects (name, color) from the labels master list.
 */

/**
 * Map an array of label IDs to label objects.
 * Returns objects with { id, name, color } for each matched ID.
 * Unresolved IDs get a fallback "Unknown Label" entry.
 *
 * @param {string[]} labelIds - Array of label IDs from lead.labels
 * @param {Array<{id:string, name:string, color:string}>} allLabels - Master label list from /api/labels
 * @returns {Array<{id:string, name:string, color:string}>}
 */
export function mapLeadLabels(labelIds, allLabels) {
  if (!labelIds || !Array.isArray(labelIds) || labelIds.length === 0) return [];
  if (!allLabels || !Array.isArray(allLabels)) return [];

  const labelMap = {};
  for (const lbl of allLabels) {
    labelMap[lbl.id] = lbl;
  }

  return labelIds.map(id => {
    const found = labelMap[id];
    return found
      ? { id: found.id, name: found.name, color: found.color || '#9ca3af' }
      : { id, name: 'Unknown Label', color: '#9ca3af' };
  });
}

/**
 * Render-ready label chip style.
 * Returns inline style object for a label chip given a color hex.
 */
export function labelChipStyle(color) {
  return {
    backgroundColor: (color || '#9ca3af') + '20',
    color: color || '#9ca3af',
  };
}
